import { OverlayLabel, OverlayRow } from './OverlayLabel';
import useWindowLevel from '~/hooks/useWindowLevel';

const WindowingLevelLabel = () => {
    const { windowLevel } = useWindowLevel();

    return (
        windowLevel && (
            <OverlayRow>
                <OverlayLabel color="primary.light">W:</OverlayLabel>
                <OverlayLabel> {windowLevel.window}</OverlayLabel>
                <OverlayLabel color="primary.light">L:</OverlayLabel>
                <OverlayLabel>{windowLevel.level}</OverlayLabel>
            </OverlayRow>
        )
    );
};

export default WindowingLevelLabel;
